import {
  ContentInputType,
  Filter,
  filterGradeChapter,
} from './parseAndDisplayPinyin';

export const parseAndBold = ({
  article,
  grade,
  chapter,
}: ContentInputType): string => {
  if (!article || !grade) {
    console.error('Article or grade is missing');
    return '';
  }

  const hanziKey = chapter ? `${grade}.${chapter}` : `${grade}`;
  const hanziMapperByGradeAndChapter = require('src/dictionary/hanzi_pinyin_list.json');
  const characters = article.split('');
  const hanziMapper = filterGradeChapter(
    hanziMapperByGradeAndChapter,
    hanziKey,
    Filter.EQUAL,
  );
  const boldArticle = characters.map((char: string) => {
    if (hanziMapper && hanziMapper[char]) {
      return `<strong>${char}</strong>`;
    }
    return char;
  });
  return boldArticle.join('').trim();
};
